export class UsuarioRelatorioDTO {
    tipo: string;
    nome: string;
    cpfCrm: string;
    celular: string;
    email: string;
    status: string;
    tipoAcesso: string;
    empresas: string;
    perfil: string;
    unidades: string;
    dataUltimoAcesso: Date;
    codPrimeiraPrescricao: string;
    dataPrimeiraPrescricao: Date;
    codUltimaPrescricao: string;
    dataUltimaPrescricao: Date;
}


export class UsuariosRelatorioParmDTO {
    nomeEmailCpfCrm: string;
    idsClientes: number[];
    idsUnidadesCliente: number[];
    idPerfil: number;
    tipoAcesso: string;
    tipoLogin: string;
    ativo: string;
}